module.exports = __webpack_public_path__ + "static/img/whitetitle.94572eb7.png";